import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ReactComponent as IconHistory } from 'src/assets/images/fortune/btn-ic-exchange-history.svg';
import { ReactComponent as IconExchange } from 'src/assets/images/fortune/btn-ic-exchange.svg';

interface FortuneHomeControlProps {
  disabled?: boolean;
}

export const FortuneHomeControl: React.FC<FortuneHomeControlProps> = ({ disabled }) => {
  const { t } = useTranslation('fortune');
  const history = useHistory();
  const handleExchangeClick = () => {
    history.push('/players/fortune/exchange');
  };
  const handleExchangeHistoryClick = () => {
    history.push('/players/fortune/exchange-history');
  };
  return (
    <div
      className={css`
        display: flex;
        justify-content: space-between;

        .spacer {
          width: 8px;
        }
        .menu-button {
          flex: 1 1 auto;
          font-size: 12px;
          min-height: 72px;
          border-radius: 36px;
          border: 4px solid #dff4b6;
          color: #6e4b22;
          background: #f4ffe0;
          transition: transform 0.1s cubic-bezier(0.17, 0.89, 0.32, 1.49), opacity 0.1s linear;
          padding: 0 10px;

          &:disabled {
            opacity: 0.4;
            pointer-events: none;
          }

          &:active {
            transform: scale(0.98);
          }
        }
        .button-content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 100%;
        }
      `}
    >
      <button className="menu-button" onClick={handleExchangeClick} disabled={disabled}>
        <div className="button-content">
          <IconExchange />
          <span>{t('exchange_items')}</span>
        </div>
      </button>

      <div className="spacer" />

      <button className="menu-button" onClick={handleExchangeHistoryClick} disabled={disabled}>
        <div className="button-content">
          <IconHistory />
          <span>{t('exchange_histories')}</span>
        </div>
      </button>
    </div>
  );
};
